<template>
  <div
    :class="[
      'form-field',
      {
        'form-field--label-left': labelLeft,
        'form-field--design-new': design === 'new'
      }
    ]"
    :style="{ marginTop: `${marginTop}px`, marginBottom: `${marginBottom}px` }"
  >
    <div v-if="label" :class="['form-field__header', { 'form-field__header--label-additional': $slots['label-additional'] }]">
      <label :for="labelFor" class="form-field__label">
        <span class="form-field__text">{{ label }}</span>
        <sup v-if="required" class="form-field__sup">*</sup>
      </label>
      <slot name="label-additional" />
    </div>
    <slot />
    <div v-if="$slots.error" class="form-field__errors">
      <slot name="error" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFormField',
  props: {
    label: String,
    labelFor: String,
    labelLeft: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    marginTop: Number,
    marginBottom: Number,
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    }
  }
}
</script>

<style lang="sass" scoped>
.form-field
  position: relative

.form-field--label-left
  display: flex
  align-items: center
  gap: 10px

  .form-field__header
    margin-bottom: 0

.form-field__header
  margin-bottom: 10px

.form-field__header--label-additional
  display: flex
  justify-content: space-between
  align-items: center

.form-field__label
  &[for]
    cursor: pointer

.form-field__sup
  color: $color-error

.form-field__text
  color: $color-text-base
  font-size: 13px
  font-weight: 500
  line-height: 15px

.form-field__errors
  color: $color-error
  font-size: 12px

  div:first-child
    margin-top: 5px

.family.form-field
  .form-field__text
    color: #303030
    font-family: 'MazzardSoftH', system-ui
    font-size: 14px
    font-weight: 500

.form-field--design-new
  font-family: $ui-font-body

  .form-field__header
    margin-bottom: $ui-space-8

  .form-field__text
    color: $ui-text
    font-size: $ui-font-size-metadata
    font-weight: 600
    line-height: 1.4

  .form-field__sup,
  .form-field__errors
    color: $ui-red

  .form-field__errors
    font-size: $ui-font-size-metadata
</style>
